import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessOverviewTimelineRoute: InvariantJiraRoute = {
	name: 'classic-business-overview-timeline',
	path: '/jira/core/overviews/:overviewId/timeline',
	exact: true,
};
